interface PriorYearImportMethod {
  name: string;
  value: string;
  bulk_supported: boolean;
}

export const PRIOR_YEAR_IMPORT_METHODS: Array<PriorYearImportMethod> = [
  {
    name: 'ATX Tax Organizer',
    value: 'atx_tax_organizer',
    bulk_supported: true,
  },
  {
    name: 'UltraTax Input Screens',
    value: 'ultratax_input_screens',
    bulk_supported: true,
  },
  {
    name: 'Lacerte Tax Organizer',
    value: 'lacerte_tax_organizer',
    bulk_supported: true,
  },
  {
    name: 'ProConnect Organizer',
    value: 'proconnect_organizer',
    bulk_supported: false,
  },
  {
    name: 'Drake Checklist',
    value: 'drake_checklist',
    bulk_supported: true,
  },
  {
    name: 'Drake Backup',
    value: 'drake_backup',
    bulk_supported: true,
  },
  {
    name: 'ProSeries Tax Organizer',
    value: 'proseries_tax_organizer',
    bulk_supported: true,
  },
  {
    name: 'Axcess Tax Organizer',
    value: 'axcess_tax_organizer',
    bulk_supported: true,
  },
  {
    name: 'TaxCycle Checklist',
    value: 'tax_cycle_checklist',
    bulk_supported: true,
  },
  {
    name: 'ProFile Return',
    value: 'profile_return',
    bulk_supported: true,
  },
  {
    name: 'TaxPrep Return (CSV)',
    value: 'taxprep_return',
    bulk_supported: true,
  },
  {
    name: 'GoSystem Tax RS Organizer',
    value: 'go_system_tax_rs_organizer',
    bulk_supported: true,
  },
  {
    name: 'ProSystem FX Tax Organizer',
    value: 'prosystem_fx_tax_organizer',
    bulk_supported: true,
  },
  {
    name: 'TaxAct Organizer',
    value: 'tax_act_organizer',
    bulk_supported: true,
  },
  {
    name: 'Tax Return',
    value: 'tax_return_for_rollover',
    bulk_supported: true,
  },
  {
    name: 'Other',
    value: 'other_organizer',
    bulk_supported: true,
  },
];
